import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	OnInit,
	signal,
} from '@angular/core';
import { StorageService } from '@context/frontend/storage';
import { getExtension, getMediaIcon } from '@context/shared/types/media';
import { AlgoliaMedia } from '@context/shared/types/search';
import { TuiAvatar } from '@taiga-ui/kit';

@Component({
	imports: [TuiAvatar],
	selector: 'ctx-algolia-media-thumbnail',
	templateUrl: 'algolia-media-thumbnail.component.html',
	styleUrl: 'algolia-media-thumbnail.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlgoliaMediaThumbnailComponent implements OnInit {
	readonly media = input.required<AlgoliaMedia>();

	readonly storageService = inject(StorageService);

	readonly thumbnailUrl = signal<string | null>(null);

	readonly icon = computed(() => {
		const ext = getExtension(this.media().name);
		return getMediaIcon(ext.slice(1));
	});

	async ngOnInit() {
		const media = this.media();
		if (!media.thumbnail) return;

		const ref = this.storageService.getReference(media.thumbnail);
		const url = await this.storageService.getDownloadUrl(ref);
		this.thumbnailUrl.set(url);
	}
}
